import {
  ESTATE_CATEGORY_ICON,
  EstateCategory,
} from '@/modules/estate/estateCategoryIcons';
import { COLORS } from '@/styles/tokens/colors';
import { EntityKind } from '@/types/schema';

export type TrustContainerVariant = EstateCategory;

export const TRUST_CONTAINER_VARIANT_ICON = ESTATE_CATEGORY_ICON;

export const TRUST_CONTAINER_VARIANT_TITLE: Record<
  TrustContainerVariant,
  string
> = {
  'in-estate': 'In estate',
  'out-of-estate-family': 'Out of estate (family)',
  'out-of-estate-charity': 'Out of estate (charity)',
};

// Trust types for each variant using EntityKind enum
export const TRUST_KINDS_BY_VARIANT: Record<
  TrustContainerVariant,
  EntityKind[]
> = {
  'in-estate': [
    EntityKind.RevocableTrust,
    EntityKind.GratTrust,
    EntityKind.QprtTrust,
  ],
  'out-of-estate-family': [
    EntityKind.IrrevocableTrust,
    EntityKind.SlatTrust,
    EntityKind.IlitTrust,
  ],
  'out-of-estate-charity': [
    EntityKind.CrtTrust,
    EntityKind.CltTrust,
    EntityKind.DonorAdvisedFund,
    EntityKind.PrivateFoundation,
  ],
};

export interface TrustContainerColors {
  iconColor: string;
  backgroundColor: string;
}

export const TRUST_CONTAINER_VARIANT_COLORS: Record<
  TrustContainerVariant,
  TrustContainerColors
> = {
  'in-estate': {
    iconColor: COLORS.NAVY[700],
    backgroundColor: COLORS.NAVY[100],
  },
  'out-of-estate-family': {
    iconColor: COLORS.TEAL[700],
    backgroundColor: COLORS.TEAL[100],
  },
  'out-of-estate-charity': {
    iconColor: COLORS.BLUE[600],
    backgroundColor: COLORS.BLUE[100],
  },
};
